/**
 *
 * Asynchronously loads the component for Steps
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Steps = lazyLoad(
  () => import('./index'),
  module => module.Steps,
);
